/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'
import { AccelByteGameService } from './AccelByteGameService.js'
import { OrganizationResponse } from './OrganizationResponse.js'
import { Platform } from './Platform.js'

export const ProjectResponse = z.object({
  accelByteGameServices: z.array(AccelByteGameService),
  agsAddons: z.array(z.string()),
  createdAt: z.string(),
  description: z.string(),
  engine: z.enum(['GODOT', 'UNITY', 'UNREAL', 'CUSTOM', 'UNKNOWN']),
  id: z.string(),
  name: z.string(),
  organization: OrganizationResponse,
  platforms: z.array(Platform),
  services: z.array(z.string()),
  status: z.enum(['UNKNOWN', 'IN_DEVELOPMENT', 'PRE_GA', 'LIVE', 'CANCELLED']),
  studios: z.array(z.string()),
  updatedAt: z.string()
})

export interface ProjectResponse extends z.TypeOf<typeof ProjectResponse> {}
